import React from 'react';
import { Modal, Divider, Button, Message, Grid, Icon } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';

class SubscriptionLimitErrorModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    close = () => {
        dispatch.app.setSubscriptionLimitError(false);
        dispatch.app.setSubscriptionLimitProps(null);
    }

    gotToUpgradePage = () => {
        dispatch.app.setSubscriptionLimitError(false);
        dispatch.app.setSubscriptionLimitProps(null);
        const history = this.props.history;
        history.push({
            pathname: `/app/${this.props.accountId}/settings/consumptionDetails`
        });
    }

 render() {
    const { subscriptionLimitProps, subscriptionLimitError, user } = this.props;
    const isCustomerAdmin = user && user.accounts && user.accounts.some(account => account.id === this.props.accountId && account.role === 'customerAdmin');
    const subProps = {
        balance: subscriptionLimitProps && subscriptionLimitProps.availableCredits || 0,
        required: subscriptionLimitProps && subscriptionLimitProps.requiredCredits || 0,
    };

    const shortfall = subProps.required - subProps.balance;

    return (
        <Modal
    className="premium-resource-modal"
    open={subscriptionLimitError}
    size="small"
    onClose={this.close}
    closeIcon={<Icon name="close" className="internal-close-icon" />}
>
    <div className="modal-inner-padding">
        <Modal.Header>
            <div className="header-title">Insufficient Credits</div>
        </Modal.Header>

        <Modal.Content>
            <div className="header-subtitle">You need additional credits to complete this action.</div>
            
            <div className="credit-comparison-row">
                {/* Current Balance */}
                <div className="credit-node">
                    <span className="node-label">Current Balance</span>
                    <div className="node-value orange-text">{subProps.balance.toLocaleString()}</div>
                </div>

                {/* Connection Bridge */}
                <div className="connector-bridge">
                    <div className="horizontal-line"></div>
                    <div className="action-pill-box">
                        <span className="pill-label">Action Cost</span>
                        <div className="pill-value">{subProps.required.toLocaleString()}</div>
                    </div>
                    <div className="horizontal-line"></div>
                </div>

                {/* Credits Required */}
                <div className="credit-node">
                    <span className="node-label">Credits Required</span>
                    <div className="node-value blue-text">+{shortfall.toLocaleString()}</div>
                </div>
            </div>

            <div className="renewal-infobox">
                <div className='renewal-icon'>
                <Icon name="clock outline" />
                </div>
                <div className="renewal-text">
                    <strong>Automatic Renewal:</strong> Your credits will automatically renew on <strong>your next billing cycle</strong> based on your current plan tier.
                </div>
            </div>
        </Modal.Content>
    </div>
        <Modal.Actions className="modal-footer-actions">
            <Button className="btn-cancel" size="tiny" onClick={this.close}>
                Cancel
            </Button>
            <Button className="button-submit" id='copyPlaybook' size="tiny" disabled={!isCustomerAdmin} onClick={this.gotToUpgradePage}>
                Upgrade Options
            </Button>
        </Modal.Actions>
</Modal>
    );
}
}

export default SubscriptionLimitErrorModal;